import React from 'react';
import { Typography, TextField, OutlinedInput } from '@mui/material';
import { conformToMask } from 'react-text-mask';
import * as masks from '../Utils/masks';
import { moneyFullFormat, unmaskValue } from '../Utils/format';

const TextFieldMain = ({
  field: fieldProp,
  form,
  ...props
}) => {
  const {
    value: fieldValue = '',
    ...fields
  } = fieldProp || {};

  let value = fieldValue;

  const {
    inputClassName,
    adicional,
    helper,
    uppercase = false,
    erro = '',
    tipoMascara,
    onChangeInput,
    onBlurInput,
    tipoComponente,
    setFieldValue,
    ...restProps
  } = props;

  const { errors = {}, ...formProps } = form || {};

  if (uppercase && typeof value === 'string') {
    value = value.toUpperCase();
  }

  if (
    (tipoMascara === 'CNPJMask' || tipoMascara === 'CPFCNPJMask') &&
    typeof value === 'string'
  ) {
    value = value.toUpperCase();
  }

  if (value === null || value === undefined) {
    value = '';
  }

  if (tipoMascara && masks[tipoMascara]) {
    value = conformToMask(value || '', masks[tipoMascara], {
      guide: false,
      keepCharPositions: true
    }).conformedValue;
  } else if (tipoMascara === 'number-float') {
    value = moneyFullFormat(unmaskValue(value), true);
  } else if (tipoMascara === 'number-money') {
    value = moneyFullFormat(unmaskValue(value));
  } else if (tipoMascara === 'number-percentual') {
    value = moneyFullFormat(unmaskValue(value), true);
  } else if (tipoMascara === 'number-inteiro') {
    value = value ? parseInt(value, 10) : 0;
  }

  const nomeInput = fields.name;
  let erroTexto = errors?.[nomeInput] ?? '';

  if (erro !== '') {
    erroTexto = erro;
  }

  const erroExiste = erroTexto !== '';

  const onChangeTextField = event => {
    if (typeof fields.onChange === 'function') {
      fields.onChange(event);
    }
    if (typeof onChangeInput === 'function') {
      onChangeInput(event, formProps);
    }
    if (tipoMascara === 'number-percentual' && typeof setFieldValue === 'function') {
      const valor = unmaskValue(event.target.value);
      if (valor > 100) {
        setFieldValue(fields.name, 100);
      }
    }
  };

  const onBlurTextField = event => {
    if (!event) return;
    if (typeof fields.onBlur === 'function') {
      fields.onBlur(event);
    }
    if (typeof onBlurInput === 'function') {
      onBlurInput(event);
    }
  };

  const classes = inputClassName
    ? inputClassName.includes('w-')
      ? inputClassName
      : `${inputClassName} w-100`
    : 'w-100';

  return (
    <>
      {tipoComponente === 'outlineInput' ? (
        <OutlinedInput
          {...restProps}
          name={fields.name}
          onChange={onChangeTextField}
          onBlur={onBlurTextField}
          value={value}
          error={erroExiste}
          className={classes}
        />
      ) : (
        <TextField
          {...restProps}
          name={fields.name}
          onChange={onChangeTextField}
          onBlur={onBlurTextField}
          value={value}
          error={erroExiste}
          className={classes}
        />
      )}

      {erroTexto !== '' ? (
        <Typography className="texto-danger label-padding label-msg-erro">{erroTexto}</Typography>
      ) : (
        ''
      )}
      {adicional}
      {helper && (
        <Typography variant="subtitle2" className="texto-cor-cinza-escuro">
          {helper}
        </Typography>
      )}
    </>
  );
};
export default TextFieldMain;
